import * as React from 'react';
import { ImportMappingsTranslation } from 'app/area/import-mappings/constants';
import styles from './import-mappings-header.scss';

interface ImportMappingsHeaderProps {
  numberOfResults: number;
  noHitsLabel: string;
  translation: ImportMappingsTranslation;
}

export const ImportMappingsHeader: React.FC<ImportMappingsHeaderProps> = ({
  numberOfResults, noHitsLabel, translation
}) => (<div className={styles.header}>
  <div className={styles.searchSummary}>
    <span id="texts_number_of_results">
      {numberOfResults === 0
        ? noHitsLabel
        : `${numberOfResults} ${translation.search_hits}`}
    </span>
  </div>
</div>);
